//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { Controller, useForm } from 'react-hook-form'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import AvatarComponent from 'app_components/commons/avatar'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import TimezoneService from 'app_services/user/timezoneService'
// @end

// @INFO Import Styles
import UserService from 'app_services/user/userService'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
import AuthService from 'app_services/secure/auth/authService'
import { UserFormAvatarInputs, UserFormGeneralInfoInputs, UserFormInputs, UserFormSections, UserFormSecurityInputs } from 'app_types/userTypes'
import InputFile from 'app_components/commons/InputFile/InputFile'
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import { MdAddAPhoto } from 'react-icons/md'
import './formUser.scss'

// @ADD Component types
interface UserFormModuleLayoutProps {
  userId: string;
  user          : any
  handleClose   : (data:any)=>void
  reviewUserInformation?: boolean;
  inputs: UserFormInputs[]
}

const UserFormModuleLayout: React.FC<UserFormModuleLayoutProps> = (props) => {

  // @INFO: Services
  const timeZoneService: TimezoneService = new TimezoneService()
  const userService: UserService = new UserService()
  const screenNotifications: ScreenNotificationsUtil = new ScreenNotificationsUtil()
  const i18nUtil: I18nUtil = new I18nUtil()
  const authService: AuthService = new AuthService()

  const {user, reviewUserInformation, inputs } = props

  const [processing, setProcessing] = useState<boolean>(false);
  const [radioValue, setRadioValue] = useState('1');
  const [listOfTimeZones, setListOfTimeZones] = useState<Array<any>>([])
  const [listOfCultures, setListOfCultures] = useState<Array<any>>([])

  const formHook = useForm()
  const { t } = useTranslation()

  const radios = [
    { name: t('modules.modal_user_form.section.general_info'), value: '1' },
    // { name: t('modules.modal_user_form.section.curriculum_vitae'), value: '2' }
  ];

  useEffect(() => {
    if (listOfTimeZones.length === 0) {
      setListOfTimeZones(timeZoneService.getAllZones())
    }
  }, [timeZoneService, listOfTimeZones])

  useEffect(() => {
    if (listOfCultures.length === 0) {
      setListOfCultures(timeZoneService.getAllCultures())
    }
  }, [timeZoneService, listOfCultures])

  const onHandleSubmit = async (data: any) => {
    setProcessing(true)

    if (data.password === '') {
      delete data.current_password
      delete data.password
      delete data.confirm_password
    }

    if (reviewUserInformation) {
      data.reviewUserInformation = true
    }

    const userResponse = await userService.insertOrUpdate(
      data,
      `update/${props.userId}`
    )

    if (userResponse) {
      let screen_notification_label = 'components.screen_notifications.update'

      screenNotifications.fireToast(
        {
          message: `${i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'bottom-right',
        }
      )

      setProcessing(false)
      if (userResponse?.passwordUpdated) {
        authService.logout()
      }
      props.handleClose({status: true})

    } else {
      setProcessing(false)
    }
  }

  const showSection = (section: UserFormSections) => {
    let items: any;
    switch (section) {
      case UserFormSections.AVATAR:
        items = UserFormAvatarInputs
        break;
      case UserFormSections.GENERAL_INFO:
        items = UserFormGeneralInfoInputs
        break;
      case UserFormSections.SECURITY:
        items = UserFormSecurityInputs
        break;
    }
    return Object.values(items).map((i: any) => inputs.includes(i)).some((i) => i === true)
  }

  return(
    <>
      {user ? (
        <form onSubmit={formHook.handleSubmit(onHandleSubmit)}>

          {showSection(UserFormSections.AVATAR) ? (
            <>
              {inputs.includes(UserFormAvatarInputs.AVATAR) ? (
                <>
                  <div className="avatar-container" style={{marginBottom: '1rem'}}>
                    <AvatarComponent src={user.profile?.avatarImageUrl} circle={true} />
                  </div>
                  <Controller
                    name='avatar'
                    control={formHook.control}
                    render={({ onChange }) => (
                      <InputFile
                        onChange={onChange}
                      >
                        <ButtonComponent className='form-user--image-button' textTransform='initial' type="button" width="100%">
                          <ButtonComponent.Icon>
                            <MdAddAPhoto />
                          </ButtonComponent.Icon>
                          Añadir imagen de perfil
                        </ButtonComponent>
                      </InputFile>
                    )}
                  />
                </>
              ): null}
            </>
          ): null}

          {/* <div className="form-type">
            <ButtonGroup toggle>
              {radios.map((radio, idx) => (
                <ToggleButton
                  key={idx}
                  type="radio"
                  variant="secondary"
                  name="radio"
                  value={radio.value}
                  checked={radioValue === radio.value}
                  onChange={(e) => setRadioValue(e.currentTarget.value)}
                >
                  {radio.name}
                </ToggleButton>
              ))}
            </ButtonGroup>
          </div> */}

          {radioValue === '1' && (
            <>
              {showSection(UserFormSections.GENERAL_INFO) ? (
                <>
                  {inputs.includes(UserFormGeneralInfoInputs.FIRST_NAME) ? (
                    <div className='form-group '>
                      <label htmlFor='first_name'>{t('labels.name')}<span className='red'>&nbsp;*</span></label>
                      {formHook.errors.profile?.first_name && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                      <input
                        id='first_name'
                        name='profile[first_name]'
                        className={`form-control ${formHook.errors.profile?.first_name && 'is-invalid'}`}
                        type='text'
                        ref={formHook.register({ required: true })}
                        defaultValue={user.profile?.first_name}
                      />
                    </div>
                  ): null}

                  {inputs.includes(UserFormGeneralInfoInputs.LAST_NAME) ? (
                    <div className='form-group '>
                      <label htmlFor='last_name'>{t('labels.last_name')}<span className='red'>&nbsp;*</span></label>
                      {formHook.errors.profile?.last_name && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                      <input
                        id='last_name'
                        name='profile[last_name]'
                        className={`form-control ${formHook.errors.profile?.last_name && 'is-invalid'}`}
                        type='text'
                        ref={formHook.register({ required: true })}
                        defaultValue={user?.profile?.last_name}
                      />
                    </div>
                  ): null}

                  {inputs.includes(UserFormGeneralInfoInputs.PHONE_NUMBER) ? (
                    <div className='form-group '>
                      <label htmlFor='phone'>{t('labels.phone_number')}</label>
                      {formHook.errors?.phoneNumber && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                      <input
                        id='phoneNumber'
                        name='phoneNumber'
                        className={`form-control ${formHook.errors?.phoneNumber && 'is-invalid'}`}
                        type='number'
                        min='0'
                        ref={formHook.register({ required: false })}
                        defaultValue={user?.phoneNumber}
                      />
                    </div>
                  ): null}

                  {inputs.includes(UserFormGeneralInfoInputs.EMAIL) ? (
                    <div className='form-group '>
                      <label htmlFor='email'>{t('labels.email')}<span className='red'>&nbsp;*</span></label>
                      {formHook.errors.email && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                      <input
                        id='email'
                        name='email'
                        className={`form-control ${formHook.errors.email && 'is-invalid'}`}
                        type='email'
                        ref={formHook.register({ required: true })}
                        defaultValue={user?.email}
                      />
                    </div>
                  ): null}

                  {inputs.includes(UserFormGeneralInfoInputs.TIMEZONE) ? (
                    <>
                      {listOfTimeZones.length > 0 ? (
                        <div className='form-group '>
                          <label htmlFor='timezone'>{t('labels.time_zone')}<span className='red'>&nbsp;*</span></label>
                          {formHook.errors.profile?.timezone && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                          <select
                            name='profile[timezone]'
                            id='timezone'
                            className={`form-control ${formHook.errors.timezone && 'is-invalid'}`}
                            ref={formHook.register({ required: false })}
                            defaultValue={user?.profile?.timezone}
                          >
                            {listOfTimeZones.map((timezone: any, i: number) => {
                              return (
                                <option value={timezone.value} key={i}>
                                  {timezone.label}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                      ): null}
                    </>
                  ): null}

                  {inputs.includes(UserFormGeneralInfoInputs.CULTURE) ? (
                    <>
                      {listOfCultures.length > 0 ? (
                        <div className='form-group '>
                          <label htmlFor='culture'>{t('labels.dialect')}<span className='red'>&nbsp;*</span></label>
                          {formHook.errors.profile_culture && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                          <select
                            id='culture'
                            name='profile[culture]'
                            className={`form-control ${formHook.errors.profile_culture && 'is-invalid'}`}
                            ref={formHook.register({ required: true })}
                            defaultValue={user?.profile?.culture}
                          >
                            {listOfCultures.map((culture: any, i: number) => {
                              return (
                                <option value={culture.value} key={i}>
                                  {culture.label}
                                </option>
                              )
                            })}
                          </select>
                        </div>
                      ): null}
                    </>
                  ): null}
                </>
              ): null}

              {showSection(UserFormSections.SECURITY) ? (
                <>
                  <div className="d-flex align-items-center mb-2" style={{justifyContent: 'center'}}>
                    <h5 className="form-title">{t("modules.modal_user_form.section.security")}</h5>
                  </div>

                  {inputs.includes(UserFormSecurityInputs.PASSWORD) ? (
                    <>
                      <div className="form-group" style={{fontSize: '.8rem'}}>
                        <div className="alert alert-warning">
                          Al cambiar tu contraseña automáticamente se cerrara la sesión actual y deberás volver a iniciar.
                        </div>
                      </div>

                      <div className={`form-group`}>
                        <label htmlFor='current_password'>{t('labels.current_password')}<span className='red'>&nbsp;*</span></label>
                        <input
                          id='current_password'
                          name='current_password'
                          type='password'
                          className={`form-control ${formHook.errors.current_password && 'is-invalid'}`}
                          ref={formHook.register({required: true})}
                          />
                        {formHook.errors.current_password && <div className='invalid-feedback' style={{display: 'inherit'}}>{t('errors.this_field_is_required')}</div>}
                      </div>

                      <div className={`form-group`}>
                        <label htmlFor='password'>{t('labels.new_password')}<span className='red'>&nbsp;*</span></label>
                        <input
                          id='password'
                          name='password'
                          type='password'
                          className={`form-control ${formHook.errors.password && 'is-invalid'}`}
                          ref={formHook.register({required: true})}
                          />
                        {formHook.errors.password && <div className='invalid-feedback' style={{display: 'inherit'}}>{t('errors.this_field_is_required')}</div>}
                      </div>

                      <div className={`form-group`}>
                        <label htmlFor='confirm_password'>{t('labels.new_password_repeat')}<span className='red'>&nbsp;*</span></label>
                        <input
                          id='confirm_password'
                          type='password'
                          name='confirm_password'
                          className={`form-control ${formHook.errors.confirm_password && 'is-invalid'}`}
                          ref={formHook.register({
                            validate: (value: any) => value === formHook.watch('password'),
                          })}
                          />
                        {formHook.errors.confirm_password && <div className='invalid-feedback' style={{display: 'inherit'}}>Error: Las dos contraseñas deben coincidir</div>}
                      </div>
                    </>
                  ): null}

                </>
              ): null}

            </>
          )}

          {radioValue === '2' && (
            <div>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Obcaecati dignissimos ut quia corporis asperiores, animi voluptates esse veniam quo ea placeat explicabo! Deserunt alias quos sed quisquam temporibus, quas perferendis.
            </div>
          )}



          <div className='buttons-group'>
            <div className='text-center'>
              <button className='btn btn-secondary' type='submit' disabled={processing}>
                {/* {props.processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)} */}
                {t('modules.modal_user_form.form.save')}
              </button>
            </div>
          </div>
        </form>
      ): (
        <div>
          <AlertComponent
            type='warning'
            title={t(`modules.modal_user_form.no_data`)}
          />
        </div>
      )}
    </>
  )
}

export default UserFormModuleLayout
